import { render } from "./Storytelling.vue?vue&type=template&id=ddac0106&scoped=true"
import script from "./Storytelling.vue?vue&type=script&lang=js"
export * from "./Storytelling.vue?vue&type=script&lang=js"

import "./Storytelling.vue?vue&type=style&index=0&id=ddac0106&lang=scss&scoped=true"

import exportComponent from "/Users/josue/Documents/projects/wwv/dapp/werewolfvalley/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddac0106"]])

export default __exports__